import { botLevels } from "./bot.js";
import { matches } from "./card_actions.js";
import { allScoreableCards } from "./scores.js";
import { state, ui, res, prefs, resetStores } from './stores.js';
import { get } from 'svelte/store';

let campaign  = {
    captain: 'Picard',
    level: 'Set Phasers to Stun',
    currentRank: 'Ensign',
    games: [
        {
            enemy: 'Sisko',
            gameID: 'sadasdasd',
            won: true,
            botLevel: '1 (Ensign)',
            reward: {
                type: 'add',
                card: {
                    full_card_info_here: true
                }
            },
            humanScore: 34,
            botScore: 22
        }
    ]
}

let prLevels = {
    'Ensign': 'You are the eternal Harry Kim.',
    'Lieutenant': 'You are Picard, but in a blue shirt.',
    'Commander': 'You are far from the bones of your ancestors.',
    'Captain': 'The California-class needs captains too...',
    'Commodore': `You'll be leading a backwater sector...`,
    'Admiral': 'Welcome to Starfleet Command!',
    'Admiral*': 'Section 31 will be in touch...',
    'Admiral**': 'The Legends: Archer, Kirk, Picard, You...'
}

export function performanceReview(campaign){
    if(!campaign.ended) return 'Campaign ongoing!';
    let finalRank = campaign.currentRank;
    if(finalRank == 'Admiral'){
        if(campaign.games.length < 7) return `The Legends: Archer, Kirk, Picard, ${campaign.username}...'`
        if(campaign.games.length < 9) finalRank = 'Admiral*';
    }
    return prLevels[finalRank];
}

export let campaignLevels = {
    'Set Phasers to Stun': [0, 1, 2, 3, 3],
    'Yellow Alert': [1, 2, 3, 3, 4],
    "Gates of Sto'Vo'Kor": [2, 3, 4, 4, 4],
    'The Ultimate Kobayashi Maru': [4, 4, 4, 4, 4]
}

export let campaignRanks = [
    'Ensign',
    'Lieutenant',
    'Commander',
    'Captain', 
    'Commodore'
]

export function humanReadableRewards(cap, winlose){
    let reward = campaignRewards[cap][winlose];
    if(reward.except){
        return `[[${reward.main}]] except [[${reward.except}]]`;
    }
    return possArray(reward).map(r => `[[${r}]]`).join('/');
}

export function specialMatch(c, match){
    if(typeof match == 'string' || Array.isArray(match)) return matches(c, match);
    if(match.main){
        if(!matches(c, match.main)) return false;
    }
    if(match.exclude){
        if(matches(c, match.exclude, false)) return false;
    }
    return true;
}

function possArray(a){
    if(!Array.isArray(a)) return [a];
    return a;
}

export function alreadyAddedCards(){
    let info = get(state).campaignInfo;
    let added = [];
    for(let g of info.games){
        if(g.reward && g.reward.card){
            added.push(...possArray(g.reward.card));
        }
    }
    return added;
}

export function eligibleRewards(won){
    let possible = campaignRewards[get(state).players.find(p => !p.bot).captain];
    if(!possible){
        alert('Opponent not yet in rewards system! Report as a bug');
        possible = [];
    }else{
        possible = possible[won ? 'win' : 'lose'];
    } 

    let reward = allScoreableCards(get(state).players[0]).filter(c => c.deck == 'Common' && /*specialMatch(c, possible)*/matches(c, possible, false, false)).filter(c => !c.suits.includes('location') && !c.suits.includes('incident') && !c.suits.includes('encounter'));
    reward = reward.filter(c => !alreadyAddedCards().some(cd => cd.id == c.id));
    return reward;
}

export let campaignRewards = {
    'Burnham': {
        'win': ['person', 'creature'],
        'lose': ['cargo', 'starfleet', 'person'],
        'win_alt': [
            {
                text: 'Draw 2 extra cards in your starting hand',
                type: 'extra_draw',
                amount: 2
            },
            {
                text: 'Add a card from Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve']
            },
        ],
        'lose_alt': [
            {
                text: 'Draw 1 extra card in your starting hand',
                type: 'extra_draw',
                amount: 1
            },
            {
                text: 'Add a card from Available (Starter) deck to Reinforcements',
                type: 'add_reserve',
                area: ['Starter']
            },
        ]
    },
    'Koloth': {
        'win': ['ship'],
        'lose': ['ship', 'attack', 'klingon'],
        'win_alt': [
            {
                text: 'Gain 3 [[military]]',
                type: 'gain',
                gain: 'military',
                amount: 3
            },
            {
                text: 'Send 1 [[away team]] at the start of each game',
                type: 'away_team',
                amount: 1
            }
        ],
        'lose_alt': [
            {
                text: 'Add a card from Available or Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve', 'Starter']
            }
        ]
    },
    'Picard': {
        'win': ['alien', 'transcendent'],
        'lose': ['ally', 'alien', 'synthetic'],
        'win_alt': [
            {
                text: 'Gain 3 [[research]]',
                type: 'gain',
                gain: 'research',
                amount: 3
            },
            {
                text: 'Choose 2 cards for your starting hand',
                type: 'choose_starter',
                amount: 2
            }
        ],
        'lose_alt': [
            {
                text: 'Gain 1 [[research]]',
                type: 'gain',
                gain: 'research',
                amount: 1
            },
            {
                text: 'Choose 1 card for your starting hand',
                type: 'choose_starter',
                amount: 1
            }
        ]
    },
    'Sela': {
        'win': ['attack', 'shady'],
        'lose': ['ship', 'attack', 'weapon'],
        'win_alt': [
            {
                text: 'Log 1 card from Starting or Reserve deck',
                type: 'log',
                area: ['Starter', 'Reserve']
            },
            {
                text: 'Add a card from Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve']
            }
        ],
        'lose_alt': [
            {
                text: 'Add a card from Starting or Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve', 'Starter']
            }
        ]
    },
    'Shran': {
        'win': ['weapon', 'business'],
        'lose': ['cargo', 'human', 'tellarite'],
        'win_alt': [
            {
                text: 'Find a location from Starter deck and free play it at start of game',
                type: 'free_play',
                filter: 'location',
                area: ['Starter']
            },
            {
                text: 'Gain 2 [[dilithium]]',
                type: 'gain',
                gain: 'dilithium',
                amount: 2
            }
        ],
        'lose_alt': [
            {
                text: 'Gain 1 [[dilithium]]',
                type: 'gain',
                gain: 'dilithium',
                amount: 1
            },
            {
                text: 'Add a card from Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve']
            }
        ]
    },
    'Sisko': {
        'win': ['anomaly', 'scientist'],
        'lose': ['cargo', 'ally', 'person'],
        'win_alt': [
            {
                text: 'Gain 3 [[influence]]',
                type: 'gain',
                gain: 'influence',
                amount: 3
            },
            {
                text: 'Gain 2 [[latinum]]',
                type: 'gain',
                gain: 'latinum',
                amount: 2
            },
        ],
        'lose_alt': [
            {
                text: 'Gain 1 [[influence]]',
                type: 'gain',
                gain: 'influence',
                amount: 1
            },
            {
                text: 'Gain 1 [[dilithium]]',
                type: 'gain',
                gain: 'dilithium',
                amount: 1
            },
        ]
    },
    'Kirk': {
        'win': ['person'],
        'lose': ['person', 'time travel', 'klingon'],
        'win_alt': [
            {
                text: 'Gain 2 on any track',
                type: 'gain',
                gain: ['research', 'influence', 'military'],
                amount: 2
            },
            {
                text: 'Whenever you play *Reinforce*, gain 1 [[dilithium]]',
                type: 'reinforce_boost',
                num: 1,
                specific: 'dilithium'
            }
        ],
        'lose_alt': [
            {
                text: 'Gain 1 on any track',
                type: 'gain',
                gain: ['research', 'influence', 'military'],
                amount: 1
            },
            {
                text: 'Add a card from Reserve deck to Reinforcements',
                type: 'add_reserve',
                area: ['Reserve']
            }
        ]
    },
    'Rebner': {
        'win': {
            main: 'cargo',
            except: 'helmet'
        },
        'lose': ['cargo', 'shady', 'attack'],
        'win_alt': [
            {
                text: 'Whenever gaining or scanning, include cards from junk',
                type: 'from_junk',
                filter: ['person', 'ship']
            },
            {
                text: 'After drawing the starting hand, gain 1 card from junk',
                type: 'starter_gain_junk',
                num: 1
            }
        ],
        'lose_alt': [
            {
                text: 'Whenever gaining a [[cargo]], include cards from the junk.',
                type: 'from_junk',
                filter: ['cargo'],
                justGain: true
            },
            {
                text: 'Whenever junking a card, gain 1 [[latinum]]',
                type: 'gain_when_junk',
                specific: 'latinum',
                num: 1
            },
        ]
    }
}

export function setCampaignRewards(c){
    campaignRewards = c;
}

export function nextRank(r){
    let i = campaignRanks.indexOf(r);
    if(i == -1) return campaignRanks[0];
    if(i == campaignRanks.length - 1) return 'Admiral';
    return campaignRanks[i+1];
}

export function getCampaignBotLevel(rank, level){
    if(typeof rank != 'number') rank = campaignRanks.indexOf(rank);
    let matrix = campaignLevels[level];
    //let i = campaignRanks.indexOf(rank);
    return botLevels()[matrix[rank]];
}
